import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Config from 'config';
import CleverIcon from '../../../../assets/clever-logo.png';
import ResourcesBox from './ResourcesBox';
import RosteringExpansionPanel, { Summary } from './RosteringExpansionPanel';
import SteppedInstructions, { Step } from './SteppedInstructions';

const Clever = () => {
  const classes = useStyles();
  const { t } = useTranslation('AdminRosterManagement');

  return (
    <RosteringExpansionPanel
      id="clever-panel"
      square={false}
      summary={<Summary title={t('cleverTitle')} subtitle={t('cleverSubtitle')} />}
      icon={<img src={CleverIcon} alt="Clever" className={classes.icon} />}
    >
      <Details />
    </RosteringExpansionPanel>
  );
};

const Details = () => {
  const { t } = useTranslation('AdminRosterManagement');

  const resourceLinks = [
    {
      href: `${Config.s3Url}/docs/Clever_Sharing_Guide_v6.pdf`,
      label: t('cleverInstructionsLabel')
    }
  ];

  return (
    <div>
      <ResourcesBox title={t('cleverResources')} resourceLinks={resourceLinks} />
      <SteppedInstructions>
        <Step number={1}>
          <Typography variant="subtitle1">
            {t('NEW and RETURNING users: ')}
            <a href={Config.rosteringSupportUrl} target="_blank" rel="noopener noreferrer">
              {t('Click here')}
            </a>
            {t(' to send us a message to schedule your requested launch date.')}
          </Typography>
          <Typography variant="subtitle1">
            {t('Note: Please view our Clever Sharing Guide (above) for best practices.')}
          </Typography>
        </Step>
        <Step number={2}>
          <Typography variant="subtitle1">
            {t(
              'An Onboarding Team Member will contact you to discuss any outstanding actions to take in order to perform the initial data sync.'
            )}
          </Typography>
        </Step>
        <Step number={3}>
          <Typography variant="subtitle1">
            {t(
              'When data sharing is approved, we will perform the initial data sync and notify you with next steps.'
            )}
          </Typography>
        </Step>
      </SteppedInstructions>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  icon: {
    width: 46,
    margin: 'auto'
  }
}));

export default Clever;
